import $ from "jquery";
import "parsleyjs";

class Forms {
    constructor() {
        this.form = document.querySelector("[data-parsley-validate]");
        this.successElem = document.getElementById("js-form--success");
        this.successMessage = document.getElementById(
            "js-form__success__message"
        );
        this.successMessageText = document.getElementById(
            "form-input-successMessage"
        );
    }

    bindForms() {
        const form = this.form;

        $(form).parsley({
            excluded: "input[type=number]",
            errorsWrapper: '<ul class="form__errors"></ul>',
            errorTemplate: '<li class="form__error"></li>',
            successClass: "form__input--success",
            errorClass: "form__input--error",
        });
    }

    init() {
        this.bindForms();
    }
}

export default Forms;



// WEBPACK FOOTER //
// ../project/craft/src/components/forms/forms.js